import type { Color } from "@pdfking/math"

export type ColorMap = Record<string, Color>
